import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { t } from '../i18n';
const API = window.location.origin + '/api';
const MyOffers = () => {
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };
  const [offers, setOffers] = useState<any[]>([]);
  const [counters, setCounters] = useState<any[]>([]);
  useEffect(() => {
    axios.get(`${API}/offers/my`,{headers}).then(res=>setOffers(res.data.offers||[]));
    axios.get(`${API}/counters/received`,{headers}).then(res=>setCounters(res.data.counters||[]));
  }, []);
  const handleRepeat = async (offer: any) => {
    try {
      await axios.post(`${API}/offers`, {
        have_items: (offer.have_items || []).map((i: any) => ({ product_id: i.product_id, quantity: i.quantity })),
        want_items: (offer.want_items || []).map((i: any) => ({ product_id: i.product_id, quantity: i.quantity })),
        cash_adjustment: offer.cash_adjustment || 0,
        note: offer.note || '',
        expires_at: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(),
      }, { headers });
      axios.get(`${API}/offers/my`,{headers}).then(res=>setOffers(res.data.offers||[]));
    } catch (err: any) { alert(err.response?.data?.error || 'Failed to repeat offer'); }
  };

  const deleteOffer = async (id:number) => { await axios.delete(`${API}/offers/${id}`,{headers}); setOffers(prev=>prev.filter(o=>o.id!==id)); };
  const acceptCounter = async (id:number) => { await axios.post(`${API}/counters/${id}/accept`,{},{headers}); setCounters(prev=>prev.filter(c=>c.id!==id)); };
  const rejectCounter = async (id:number) => { await axios.post(`${API}/counters/${id}/reject`,{},{headers}); setCounters(prev=>prev.filter(c=>c.id!==id)); };
  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 mb-6">{t('myOffers','My Offers')}</h1>
      {counters.length>0&&(
        <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-5 shadow-sm mb-6">
          <h3 className="font-semibold text-yellow-800 mb-3">⚡ Counter Offers Received ({counters.length})</h3>
          <div className="space-y-3">{counters.map(c=>(
            <div key={c.id} className="bg-white rounded-lg p-4 border border-yellow-100">
              <p className="text-sm text-gray-900 mb-1"><span className="font-medium">{c.have_quantity}x {c.have_product_name}</span>{' ↔ '}<span className="font-medium">{c.want_quantity}x {c.want_product_name}</span></p>
              {c.cash_adjustment!==0&&<p className="text-xs text-gray-500 mb-2">Cash: {c.cash_adjustment>0?`+€${c.cash_adjustment}`:`-€${Math.abs(c.cash_adjustment)}`}</p>}
              {c.note&&<p className="text-xs text-gray-400 mb-3">{c.note}</p>}
              <div className="flex gap-2">
                <button onClick={()=>acceptCounter(c.id)} className="px-3 py-1.5 rounded-lg text-white text-xs font-medium" style={{backgroundColor:'#B8860B'}}>Accept</button>
                <button onClick={()=>rejectCounter(c.id)} className="px-3 py-1.5 rounded-lg bg-gray-100 text-gray-600 text-xs font-medium">Reject</button>
              </div>
            </div>
          ))}</div>
        </div>
      )}
      {offers.length===0?<div className="bg-white border border-gray-200 rounded-xl p-8 text-center shadow-sm"><p className="text-gray-400 text-sm">No active offers</p></div>:(
        <div className="space-y-3">{offers.map(o=>(
          <div key={o.id} className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-900">{o.have_quantity}x {o.have_product_name}<span className="text-gray-400 mx-2">↔</span>{o.want_quantity}x {o.want_product_name}</p>
                {o.cash_adjustment!==0&&<p className="text-xs text-gray-500 mt-1">{o.cash_adjustment>0?`I request +€${o.cash_adjustment}`:`I offer €${Math.abs(o.cash_adjustment)}`}</p>}
                {o.note&&<p className="text-xs text-gray-400 mt-1">{o.note}</p>}
                {o.expires_at&&<p className="text-xs text-gray-400 mt-1">Expires: {new Date(o.expires_at).toLocaleDateString()}</p>}
              </div>
              <div className="flex gap-3 ml-4">
                  <button onClick={()=>handleRepeat(o)} className="text-xs hover:opacity-70" style={{color:'#B8860B'}}>Repeat</button>
                  <button onClick={()=>deleteOffer(o.id)} className="text-xs text-red-400 hover:text-red-600">Delete</button>
                </div>
            </div>
          </div>
        ))}</div>
      )}
    </div>
  );
};
export default MyOffers;
